interface EpiWindow {
    epi?: {
        EPiServer?: {
            Forms?: {
                Validators?: Record<string, unknown>;
            };
        };
    };
}

(function () {
    function registerValidator(): boolean {
        const w = window as unknown as EpiWindow;

        if (!w.epi || !w.epi.EPiServer || !w.epi.EPiServer.Forms || !w.epi.EPiServer.Forms.Validators) {
            return false;
        }

        w.epi.EPiServer.Forms.Validators["Vgr.Cms.Business.FormSubmitionCustomization.CustomEmailValidator"] =
            function (fieldName: string, fieldValue: string, validatorMetaData: unknown) {
                if (!fieldValue || !fieldValue.trim()) {
                    return { isValid: true };
                }
                if (fieldValue.indexOf("@") === -1) {
                    return { isValid: false, message: "E-postadressen måste innehålla ett @" };
                }
                const parts = fieldValue.split("@");
                if (!parts[0]) {
                    return { isValid: false, message: "E-postadressen måste innehålla ett värde innan @" };
                }
                if (!parts[1]) {
                    return { isValid: false, message: "E-postadressen måste innehålla ett värde efter @" };
                }
                const dotIndex = parts[1].indexOf(".");
                if (dotIndex === -1 || dotIndex === parts[1].length - 1) {
                    return { isValid: false, message: "E-postadressen måste innehålla en domän, t.ex. .se eller .com" };
                }
                return { isValid: true };
            };

        return true;
    }

    if (!registerValidator()) {
        const interval = setInterval(function () {
            if (registerValidator()) {
                clearInterval(interval);
            }
        }, 50);
    }
})();
